import style from "./DataCorrectionSubmitGrid.module.css";

const DataCorrectionSubmitGrid = ({ tableData, isSubjectRemoved = false }) => {
  return (
    <div className={style.tableWrapper}>
      <table className={style.table}>
        <thead>
          <tr>
            <th className={`${style.thSpacing} ${style.firstCol}`}>Field</th>
            <th className={style.thSpacing}>Current Value</th>
            <th className={style.thSpacing}>Requested Value</th>
            {!isSubjectRemoved && <th className={style.thSpacing}>Removed </th>}
          </tr>
        </thead>

        <tbody>
          {tableData.map((field, index) => {
            const removeFieldName =
              field?.removeFieldName ||
              `removeValue_${field?.answer_id || index}`;

            return (
              <tr key={field?.answer_id || index} className={style.trBorder}>
                <td className={`${style.thSpacing} ${style.firstCol}`}>
                  {field?.fieldName || field?.label || "-"}
                </td>

                <td className={style.thSpacing}>
                  {field?.currentValue ?? "-"}
                </td>

                <td className={style.thSpacing}>{field?.requestedValue}</td>
                {!isSubjectRemoved && (
                  <td className={style.thSpacing}>
                    {field?.removeValue ? "True" : "False"}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DataCorrectionSubmitGrid;
